import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Home2 from "./Home2";
import ShippingInfo from "./ShippingInfo";
import Layout from "./Layout";
import Processing from "./Processing";
import ComingSoon from "./Coming-Soon";
import HomeYeni from "./HomeYeni";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <ComingSoon />
            </Layout>
          }
        />
        <Route
          path="/1"
          element={
            <Layout>
              <HomeYeni />
            </Layout>
          }
        />
        <Route
          path="/2"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/3"
          element={
            <Layout>
              <Home2 />
            </Layout>
          }
        />

        <Route
          path="/4"
          element={
            <Layout>
              <ShippingInfo />
            </Layout>
          }
        />
        <Route
          path="/5"
          element={
            <Layout>
              <Processing />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
